export const SCORM_CONFIG_MIGRATION = [
  /*{
    from: '1.0.0',
    to: '1.1.0',
    function: vraiFauxMigrator,
  },*/
];

export const SCORM_LATEST_VERSION = SCORM_CONFIG_MIGRATION.length
  ? SCORM_CONFIG_MIGRATION[SCORM_CONFIG_MIGRATION.length - 1].to
  : '1.0.0';
